import React from "react";
import { Link } from "react-scroll";

function HomeSection() {
  return (
    <section id="home" className="section hero">
      <div className="hero__content hero__grid">
        <div>
          <h1>
            The only clinic platform with a <span>built-in <br />patient experience.</span>
          </h1>
          <p>
            From queue to consultation to follow-up, byond care connects your clinic
            with your patients through their own personal health app.
          </p>
          <div className="hero__actions">
            <Link to="demo" smooth duration={500} offset={-70} className="btn">
              Book a Demo
            </Link>
            <Link to="pricing" smooth duration={500} offset={-70} className="btn btn--light">
              See Pricing
            </Link>
          </div>
          <div className="hero__trust">
            <div className="hero__trust-dots" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </div>
            <p>Trusted by clinics across Malaysia</p>
          </div>
        </div>
        <div className="hero-banner">
          <img src="/images/banner.png" alt="byond care dashboard and app banner" />
        </div>
      </div>
    </section>
  );
}

export default HomeSection;
